//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "../../shared/components";
import { LoadingContext } from "../../shared/context/LoadingContext"
import { Main } from "./components";
import { loadGroupsProductsService } from "./services/";
import { TrackingContext } from "./context/TrackingContext";



//--------------- EXPORTAÇÃO DA PÁGINA TRACKING RELATÓRIO ---------------//
export default function TrackingRelatorio() {



  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const { isLoading, setIsLoading } = useContext(LoadingContext); // Estado que armazena se a tela de carregamento está aparecendo ou não (inicia aparecendo)
  const { groupProducts, setGroupProducts } = useContext(TrackingContext);



  //-------------- USE EFFECT DE INICIALIZAÇÃO --------------//
  useEffect(() => {
    handleLoadingGroupsProducts();
  }, []);



  //-------------- FUNÇÃO ASSÍNCRONA CARREGAR GRUPOS DE PRODUTOS --------------//
  async function handleLoadingGroupsProducts() {
    setIsLoading(true);
    const response = await loadGroupsProductsService();
    if (response) {
      setGroupProducts(response.data);
    }
    setIsLoading(false);
  };



  //--------------- RETORNO CONDICIONAL DA PÁGINA TRACKING RELATÓRIO ---------------//
  return (
    <>
      {isLoading && groupProducts
        ? <Loading />
        : <Main />
      }
    </>
  )
}